'use client';

import { useMemo, useState } from 'react';
import type { FacilityData, FacilitySection } from '@/app/_lib/parseFacilities';
import { EnhancedMapWrapper } from './EnhancedMapWrapper';
import { FacilityLegend } from './FacilityLegend';
import { InteractiveLocations } from './InteractiveLocations';
interface LocationsClientProps {
  initialFacilitySections: FacilitySection[];
  corporateOffice: {
    title: string;
    phone: string;
    address: {
      street: string;
      city: string;
      state: string;
      zipcode: string;
    };
  };
  currentFacilityName?: string;
}
export function LocationsClient({
  initialFacilitySections,
  currentFacilityName
}: LocationsClientProps) {
  // Use the geocoded data passed from server
  const facilitySections = initialFacilitySections;
  const allFacilities = useMemo(() => initialFacilitySections.flatMap(section => section.facilities), [initialFacilitySections]);

  // Find the current facility based on APP_NAME from env
  const initialFacility = useMemo(() => {
    if (!currentFacilityName) return null;
    return allFacilities.find(f => f.name === currentFacilityName) || null;
  }, [allFacilities, currentFacilityName]);
  const [selectedFacility, setSelectedFacility] = useState<FacilityData | null>(initialFacility);
  const handleFacilityClick = (facility: FacilityData) => {
    setSelectedFacility(facility);
  };
  return <>
      {/* Map */}
      <div className='mb-12' id='map-container'>
        <EnhancedMapWrapper facilities={allFacilities} selectedFacility={selectedFacility} />
      </div>

      {/* Legend */}
      <FacilityLegend />

      {/* Interactive Facilities Grid */}
      <InteractiveLocations facilitySections={facilitySections} onFacilityClick={handleFacilityClick} selectedFacility={selectedFacility} />
    </>;
}
export default LocationsClient;